// ⚠️ AUTO-GENERATED FROM CORE REPO
// DO NOT EDIT — changes will be overwritten

/* Presentation only: no cart mutations, eligibility rules or tier calculations. */
(() => {
  if (customElements.get("goat-discount-price")) return;
  class GoatDiscountPrice extends HTMLElement {
    connectedCallback() {
      this.update = (event) => this.renderPrice(event.detail);
      window.addEventListener("goat-discounts:prices-updated", this.update);
      this.onStatus = () => this.renderPrice(window.GoatDiscountsPricing?.latest);
      window.addEventListener("goat-discounts:status-updated", this.onStatus);
      this.onVariant = (event) => {
        if (
          this.dataset.presentation !== "pdp" ||
          String(event.detail?.productId) !== this.dataset.productId
        )
          return;
        this.setVariant(event.detail.variant, event.detail.planId);
      };
      window.addEventListener("goat-discounts:variant-changed", this.onVariant);
      this.onPurchase = (event) => {
        if (
          this.dataset.presentation !== "pdp" ||
          String(event.detail?.productId) !== this.dataset.productId
        )
          return;
        const variants = JSON.parse(
          this.querySelector("[data-price-variants]")?.textContent || "[]",
        );
        const variant = variants.find(
          (item) => String(item.id) === this.dataset.variantId,
        );
        if (variant) this.setVariant(variant, event.detail.planId);
      };
      window.addEventListener(
        "goat-discounts:purchase-type-changed",
        this.onPurchase,
      );
      this.renderPrice(window.GoatDiscountsPricing?.latest);
      window.GoatDiscountsPricing?.refresh();
    }
    disconnectedCallback() {
      window.removeEventListener("goat-discounts:prices-updated", this.update);
      window.removeEventListener("goat-discounts:status-updated", this.onStatus);
      window.removeEventListener(
        "goat-discounts:variant-changed",
        this.onVariant,
      );
      window.removeEventListener(
        "goat-discounts:purchase-type-changed",
        this.onPurchase,
      );
    }
    setVariant(variant, planId = "") {
      const allocation = variant.selling_plan_allocations?.find(
        (item) => String(item.selling_plan_id) === String(planId),
      );
      this.dataset.variantId = String(variant.id);
      this.dataset.unitPriceMinor = String(
        allocation ? allocation.price : variant.price,
      );
      this.dataset.comparePriceMinor = String(
        allocation
          ? allocation.compare_at_price || variant.price
          : variant.compare_at_price || 0,
      );
      this.toggleAttribute(
        "data-goat-price",
        !planId && this.dataset.productExcluded !== "true",
      );
      this.renderPrice(window.GoatDiscountsPricing?.latest);
      document.dispatchEvent(new Event("goat-discounts:registrations-changed"));
    }
    renderPrice(quote) {
      const loading =
        this.hasAttribute("data-goat-price") &&
        this.dataset.presentation !== "pdp" &&
        document.documentElement.dataset.goatPricingState === "loading";
      this.setAttribute("aria-busy", String(loading));
      const base = Number(this.dataset.unitPriceMinor),
        compare = Number(this.dataset.comparePriceMinor);
      const price =
        this.hasAttribute("data-goat-price") && quote?.active
          ? quote.prices.find(
              (price) => price.variantId === this.dataset.variantId,
            )
          : null;
      const discounted = price?.eligible && price.amountOffMinor > 0;
      const final = discounted ? price.finalPriceMinor : base,
        previous = discounted ? base : compare;
      const money = (minor) =>
        new Intl.NumberFormat(document.documentElement.lang || "en-US", {
          style: "currency",
          currency: this.dataset.currency || "USD",
        }).format(minor / 100);
      const current = this.querySelector("[data-price-current]"),
        old = this.querySelector("[data-price-compare]"),
        badge = this.querySelector("[data-price-badge]");
      if (!current || !old) return;
      const before = this.priceState;
      current.textContent = money(final);
      old.textContent = money(previous);
      old.hidden = previous <= final;
      this.classList.toggle("is-discounted", discounted || compare > base);
      const savings = previous > final ? previous - final : 0;
      if (badge) {
        badge.hidden = !savings;
        badge.textContent = savings
          ? this.dataset.badgeType === "percentage"
            ? `SAVE ${Math.round((savings / previous) * 100)}%`
            : `SAVE ${money(savings).replace(/\.00$/, "")}`
          : "";
      }
      const next = {
        current: current.textContent,
        compare: old.hidden ? null : old.textContent,
        badge: !badge || badge.hidden ? null : badge.textContent,
      };
      if (this.priceReady && !loading && before) {
        if (before.current !== next.current)
          window.GoatDiscountMotion?.pulse(current);
        if (next.compare !== null && before.compare !== next.compare)
          window.GoatDiscountMotion?.pulse(old);
        if (next.badge !== null && before.badge !== next.badge)
          window.GoatDiscountMotion?.pulse(badge);
      }
      this.priceState = next;
      this.priceReady = !!quote && !loading;
    }
  }
  customElements.define("goat-discount-price", GoatDiscountPrice);
})();
